import { render, staticRenderFns } from "./ContactCustomFieldsForm.vue?vue&type=template&id=f0c29dcc&scoped=true&"
import script from "./ContactCustomFieldsForm.vue?vue&type=script&lang=js&"
export * from "./ContactCustomFieldsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c29dcc",
  null
  
)

export default component.exports